const UPDATE_PASSWORD_PAGE_CSS_IDENTIFIERS = Object.freeze({
  block: 'c-update-password-page',
});

const UPDATE_PASSWORD_PAGE_CONSTANTS = Object.freeze({
  cssIdentifiers: UPDATE_PASSWORD_PAGE_CSS_IDENTIFIERS,
});

export { UPDATE_PASSWORD_PAGE_CONSTANTS };
